import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TourPackageService from "../../services/tourpackage.service";

export const gettravelPackageList = createAsyncThunk(
  "travelPackage/gettravelPackageList",
  async (item, thunkApi) => {
    try {
      const data = await TourPackageService.gettravelPackageList(item);
      return { packages: data };
     
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getsimilartravelPackageList = createAsyncThunk(
  "travelPackage/getsimilartravelPackageList",
  async (item, thunkApi) => {
    try {
      const data = await TourPackageService.getsimilarPackage(item);
      return { similarPackages: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const getspecialtravelPackageList = createAsyncThunk(
  "travelPackage/getspecialtravelPackageList",
  async (item, thunkApi) => {
    try {
      const data = await TourPackageService.getspecialPackage(item);
      return { specialPackages: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const postEnquiry = createAsyncThunk(
  "travelPackage/postEnquiry",
  async (item, thunkApi) => {
    try {
      const data = await TourPackageService.postenquiry(item);
      return { enquiry: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const travelPackagePrice = createAsyncThunk(
  "travelPackage/travelPackagePrice",
  async (item, thunkApi) => {
    try {
      const data = await TourPackageService.travelpackageprice(item);
      return { packagePrice: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

export const gettravelCategoryList = createAsyncThunk(
  "travelCategory/gettravelCategoryList",
  async (item, thunkApi) => {
    try {
      const data = await TourPackageService.gettravelCategoryList(item);
      return { categories: data };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkApi.rejectWithValue({ message });
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  packages: [],
  similarPackages: [],
  specialPackages: [],
  packagePrice: null,
  enquiry: null,
  categories: [],
  isLoggedIn: false,
};

const travelPackageSlice = createSlice({
  name: "travelPackage",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(gettravelPackageList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(gettravelPackageList.fulfilled, (state, action) => {
        state.loading = false;
        state.packages = action.payload.packages;
      })
      .addCase(gettravelPackageList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // Similar Packages
      .addCase(getsimilartravelPackageList.fulfilled, (state, action) => {
        state.similarPackages = action.payload.similarPackages;
      })
      // Special Packages
      .addCase(getspecialtravelPackageList.fulfilled, (state, action) => {
        state.specialPackages = action.payload.specialPackages;
      })
      // Travel Package Price
      .addCase(travelPackagePrice.fulfilled, (state, action) => {
        state.packagePrice = action.payload.packagePrice;
      })
      // Enquiry Posting
      .addCase(postEnquiry.fulfilled, (state, action) => {
        state.enquiry = action.payload.enquiry;
      })
      // Category List
      .addCase(gettravelCategoryList.fulfilled, (state, action) => {
        state.categories = action.payload.categories;
      });
  },
});

export default travelPackageSlice.reducer;
